<template>
  
  <v-list-item>

    <v-list-item-content class="py-1">
      <v-list-item-title>
        {{ invitation.email }}
      </v-list-item-title>
      <v-list-item-subtitle>
        {{$t('orders.share_expires_at')}}: {{ $formatDateNoTime(invitation.expiresAt) }}        
      </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action>
      <v-menu bottom left>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" icon><hb-icon>more_vert</hb-icon></v-btn>
        </template>
        <v-list dense class="pa-0">
          <v-list-item @click="deleteClicked" :disabled="$isImpersonating">
            <v-list-item-avatar><v-icon>delete</v-icon></v-list-item-avatar>
            <v-list-item-title>{{ $t('orders.delete_invitation')}}</v-list-item-title>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item @click="() => {}">
            <v-list-item-avatar>
              <v-icon>close</v-icon>
            </v-list-item-avatar>
            <v-list-item-title>{{ $t('close_menu') }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-list-item-action>

  </v-list-item>
</template>

<script>
export default {
  name: 'ShareOrderInvitationRow',
  props: ['invitation'],
  emits: ['click:delete'],
  methods: {
    deleteClicked() {
      this.$emit('click:delete', this.invitation);
    }
  }
}
</script>

<style scoped>

</style>